import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import Switch from '@/components/DSE/Switch';
import { validatorRequire } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    code: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 2,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    euYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'country.eu',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    currencyID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'common.currency',
        required: true,
        valueField: 'id',
        labelField: 'description',
        loading: vue.$store.getters['currency/isLoading'],
        options: vue.$store.getters['currency/loadedItems']
      },
      rules: [{ validator: validatorRequire }]
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
